export enum DateTimeRangeMode {
  "date", "range", "last", "empty"
}

export enum DateTimeRangePeriod {
  "days", "weeks", "months", "years"
}

export type DateTimeRange = {
  mode: keyof typeof DateTimeRangeMode,
  date: string | null,
  from: string | null,
  to: string | null,
  amount: number | null,
  period: keyof typeof DateTimeRangePeriod,
}


export const defaultDateTimeRangeValue: DateTimeRange = {
  date: null,
  from: null,
  to: null,
  period: "days",
  amount: 3,
  mode: "date",
};

Object.freeze(defaultDateTimeRangeValue);
